import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupSuccessVerificationFormComponent } from '../../ui/signup-success-verification-form/signup-success-verification-form.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'equine-ui-nx-signup-success',
  standalone: true,
  imports: [CommonModule, SignupSuccessVerificationFormComponent],
  templateUrl: './signup-success-verification.component.html',
  styleUrl: './signup-success-verification.component.css',
})
export class SignupSuccessVerificationComponent implements OnInit, OnDestroy {
  appName!: string;
  unsubscribe$ = new Subject<void>();
  constructor(
    private router: Router,
    private readonly activatedRoute: ActivatedRoute
  
  ) {}
  
  ngOnInit(): void {
    this.activatedRoute.data.pipe(takeUntil(this.unsubscribe$))
    .subscribe((data: any)=>{
      this.appName = data.appName;
    })
  }
  navigateToLogin() {
    this.router.navigate(['account','login']);
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
